import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=2642720e"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/22487/45/StockShop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2642720e')) {
      api.createRecord('2642720e', component.options)
    } else {
      api.reload('2642720e', component.options)
    }
    module.hot.accept("./Icon.vue?vue&type=template&id=2642720e", function () {
      api.rerender('2642720e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/pageDesign/Icon.vue"
export default component.exports